interface ActiveFilterTagsProps {
  searchQuery: string;
  category: string;
  location: string;
  locationLabel: string;
  jobType: string;
  sortBy: string;
  onClearSearch: () => void;
  onClearCategory: () => void;
  onClearLocation: () => void;
  onClearJobType: () => void;
  onClearSort: () => void;
  onClearAll: () => void;
}

const jobTypeLabels: Record<string, string> = {
  "full-time": "Toàn thời gian",
  "part-time": "Bán thời gian",
  contract: "Hợp đồng",
};

const sortLabels: Record<string, string> = {
  newest: "Mới nhất",
  oldest: "Cũ nhất",
  "salary-high": "Lương cao → thấp",
  "salary-low": "Lương thấp → cao",
};

interface Tag {
  key: string;
  label: string;
  onClear: () => void;
  type: "search" | "category" | "location" | "type" | "sort";
}

const tagColors: Record<Tag["type"], string> = {
  search: "bg-accent-100 text-accent-700 border-accent-200/70",
  category: "bg-primary-100 text-primary-700 border-primary-200/70",
  location: "bg-secondary-100 text-secondary-700 border-secondary-200/70",
  type: "bg-accent-100 text-accent-700 border-accent-200/70",
  sort: "bg-background-200 text-foreground-600 border-background-300/60",
};

export default function ActiveFilterTags({
  searchQuery,
  category,
  location,
  locationLabel,
  jobType,
  sortBy,
  onClearSearch,
  onClearCategory,
  onClearLocation,
  onClearJobType,
  onClearSort,
  onClearAll,
}: ActiveFilterTagsProps) {
  const tags: Tag[] = [];

  if (searchQuery) {
    tags.push({ key: "search", label: `"${searchQuery}"`, onClear: onClearSearch, type: "search" });
  }
  if (category) {
    tags.push({ key: "category", label: category, onClear: onClearCategory, type: "category" });
  }
  if (location) {
    tags.push({ key: "location", label: locationLabel, onClear: onClearLocation, type: "location" });
  }
  if (jobType) {
    tags.push({ key: "type", label: jobTypeLabels[jobType] || jobType, onClear: onClearJobType, type: "type" });
  }
  if (sortBy && sortBy !== "newest") {
    tags.push({ key: "sort", label: sortLabels[sortBy] || sortBy, onClear: onClearSort, type: "sort" });
  }

  if (tags.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 mb-6">
      <span className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mr-1 whitespace-nowrap">
        Đang lọc:
      </span>
      {tags.map((tag) => (
        <span
          key={tag.key}
          className={`inline-flex items-center gap-1 px-3 py-1.5 rounded-full text-xs font-medium border ${tagColors[tag.type]}`}
        >
          <span>{tag.label}</span>
          <button
            onClick={tag.onClear}
            className="flex items-center justify-center w-4 h-4 rounded-full hover:bg-black/10 transition-colors cursor-pointer"
            aria-label={`Xóa bộ lọc ${tag.label}`}
          >
            <i className="ri-close-line text-xs"></i>
          </button>
        </span>
      ))}
      {tags.length > 1 && (
        <button
          onClick={onClearAll}
          className="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-full text-xs font-medium text-foreground-500 hover:text-red-500 hover:bg-red-50 transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-delete-back-line"></i>
          Xóa tất cả
        </button>
      )}
    </div>
  );
}